var ReadingTime = function () {
    var _a, _b;
    var source = (_a = document.querySelector('.news-single')) !== null && _a !== void 0 ? _a : document.createElement('div');
    var target = (_b = document.querySelector('.eta')) !== null && _b !== void 0 ? _b : document.createElement('div');
    var WORDS_PER_MINUTE = 160;
    var getContent = function () { return (source.textContent.split(" ").filter(function (item) { return item !== "" && item !== "\n"; })); };
    var calculateReadingTime = function () { return (Math.ceil(getContent().length / WORDS_PER_MINUTE)); };
    target.textContent = "".concat(calculateReadingTime().toString(), " Minute").concat(calculateReadingTime() > 1 ? 'n' : '');
};
export default ReadingTime;
